import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getAuditModelListPath } from "../../services/config";
import { config } from "../../services/configHeader";

const baseUrl = process.env.REACT_APP_BASE_URI;

let initialState = {
  salaryLoading: false,
  salarySuccess: false,
  salaryError: false,
  salaryMessage: null,

  salaryGetLoading: false,
  salaryGetSuccess: false,
  salaryGetError: false,
  salaryGetMessage: null,
  salaryGetData: null,
};

const user = localStorage.getItem("user_data")
  ? JSON.parse(localStorage.getItem("user_data"))
  : null;

const userId = user?.user_id;
const accountType = user?.account_type;

export const fetchSalaryData = createAsyncThunk(
  "fetchSalaryData",
  async (data) => {
    const { userId, outletId } = data;
    return await axios
      .get(`${baseUrl}${getAuditModelListPath(userId, outletId)}`, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            data: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
          };
          return data;
        } else {
          return error;
        }
      });
  }
);

export const saveUpdateSalary = createAsyncThunk(
  "saveUpdateSalary",
  async (body) => {
    const result = {
      data: {
        message: "Sorry, you can only view the data, not create it.",
        data: [],
      },
    };

    const { path, data } = body;

    return parseInt(accountType) === 2
      ? result
      : await axios
          .post(`${baseUrl}${path}`, data, config)
          .then((response) => {
            return response;
          })
          .catch((error) => {
            if (!navigator.onLine) {
              console.log(
                "You are offline. Please check your internet connection."
              );
            } else {
              console.log("An error occurred. Please try again later.");
            }
            let data = {
              response: {
                data: [],
                message: "No Internet Connection Found",
                success: false,
              },
            };
            return data;
          });
  }
);

const salarySlice = createSlice({
  name: "salary",
  initialState,

  reducers: {
    initSalaryState: (state) => {
      state.salaryLoading = false;
      state.salarySuccess = false;
      state.salaryError = false;
      state.salaryMessage = null;

      state.salaryGetLoading = false;
      state.salaryGetSuccess = false;
      state.salaryGetError = false;
      state.salaryGetMessage = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchSalaryData.pending, (state, action) => {
      state.salaryGetLoading = true;
      state.salaryGetSuccess = false;
      state.salaryGetError = false;
      state.salaryGetMessage = null;
      state.salaryGetData = null;
    });
    builder.addCase(fetchSalaryData.fulfilled, (state, action) => {
      const status = action.payload.status;

      if (status == 200) {
        state.salaryGetLoading = false;
        state.salaryGetSuccess = true;
        state.salaryGetError = false;
        state.salaryGetMessage = action.payload.data.message;
        state.salaryGetData = action.payload.data.data;
      } else {
        state.salaryGetLoading = false;
        state.salaryGetSuccess = false;
        state.salaryGetError = true;
        state.salaryGetMessage = action.payload.response.data.message;
        state.salaryGetData = null;
      }
    });
    builder.addCase(fetchSalaryData.rejected, (state, action) => {
      state.salaryGetLoading = false;
      state.salaryGetSuccess = false;
      state.salaryGetError = true;
      state.salaryGetMessage = action.payload.data.message;
      state.salaryGetData = null;
    });

    // To create branch
    builder.addCase(saveUpdateSalary.pending, (state, action) => {
      state.salaryLoading = true;
      state.salarySuccess = false;
      state.salaryError = false;
      state.salaryMessage = null;
    });
    builder.addCase(saveUpdateSalary.fulfilled, (state, action) => {
      const status = action.payload.status;
      if (status == 200 || status == 201) {
        if (
          action.payload.data.status == true ||
          action.payload.data.status == "true"
        ) {
          state.salaryLoading = false;
          state.salarySuccess = true;
          state.salaryError = false;
          state.salaryMessage = action.payload.data.message;
        } else {
          state.salaryLoading = false;
          state.salarySuccess = false;
          state.salaryError = true;
          state.salaryMessage = action.payload.data.message ? action.payload.data.message : action.payload.data.msg;
        }
      } else {
        state.salaryLoading = false;
        state.salarySuccess = false;
        state.salaryError = true;
        state.salaryMessage = action.payload.response.data.message;
      }
    });
    builder.addCase(saveUpdateSalary.rejected, (state, action) => {
      state.salaryLoading = false;
      state.salarySuccess = false;
      state.salaryError = true;
      state.salaryMessage = action.payload.data.message;
    });
  },
});

export const { initSalaryState } = salarySlice.actions;

export default salarySlice.reducer;
